export const ADMIN_USER_ACCESS_PREFIX = 'TENANT-ADMIN-PREFIX_';

export const SEARCH_REFRESH = ADMIN_USER_ACCESS_PREFIX + 'SEARCH_REFRESH';

export const FETCH_ADMIN_TENANT_LIST = ADMIN_USER_ACCESS_PREFIX + 'ADMIN_TENANT_LIST';

export const FETCH_ADMIN_ROLE_LIST = ADMIN_USER_ACCESS_PREFIX + 'ADMIN_ROLE_LIST';
